import React from 'react';
import { useReveal } from '../lib/useReveal';
const CHECKOUT = 'https://megapack-maestria-reiki.impultienda.ar/checkout';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/j6YLFUuXnRWi5SPaEJqowo/ChatGPT_Image_22_jun_2026,_21_32_29.png';
export function ClosingSection() {
  const [ref1, vis1] = useReveal();
  return <section className="relative bg-[#1A1625] text-white py-24 md:py-32 px-5 sm:px-6 overflow-hidden border-t border-[#342D45]" data-id="element-101">
      {/* Soft glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#D4AF37]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-102"></div>

      <div ref={ref1} className={`reveal container mx-auto max-w-4xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-103">
        <h2 className="text-4xl md:text-6xl font-bold mb-16 leading-tight max-w-3xl mx-auto" style={{
        fontFamily: "'Playfair Display', serif"
      }} data-id="element-104">
          Hoy puede ser el comienzo de un nuevo camino.
        </h2>

        <div className="max-w-xl mx-auto mb-12" data-id="element-105">
          <img src={HERO_IMG} alt="MegaPack Maestría Reiki" className="w-full max-h-[400px] object-contain block mx-auto drop-shadow-[0_30px_60px_rgba(0,0,0,0.5)] mb-12" data-id="element-106" />

          <p className="text-6xl md:text-7xl font-extrabold text-white leading-none mb-4 tracking-tight" data-id="element-107">
            $19.990
          </p>
          <p className="text-[#D4AF37] text-sm font-bold uppercase tracking-widest mb-10" data-id="element-108">
            ARS · Pago único
          </p>

          <a href={CHECKOUT} target="_blank" rel="noopener noreferrer" className="cta-btn w-full block py-6 md:py-7 rounded-2xl text-[#1A1625] font-extrabold text-xl md:text-2xl tracking-wide uppercase text-center bg-[#D4AF37] shadow-[0_20px_50px_rgba(212,175,55,0.3)] hover:shadow-[0_25px_60px_rgba(212,175,55,0.4)] hover:bg-[#E5C358] transition-all" style={{
          fontFamily: "'Inter', sans-serif",
          letterSpacing: '0.05em'
        }} data-id="element-109">
            Quiero Comenzar Hoy
          </a>
        </div>

        <div className="flex flex-wrap justify-center gap-6 md:gap-10 text-white/60 text-sm font-medium" data-id="element-110">
          <span className="flex items-center gap-2" data-id="element-111">🔒 Pago seguro</span>
          <span className="flex items-center gap-2" data-id="element-112">⚡ Acceso inmediato</span>
          <span className="flex items-center gap-2" data-id="element-113">🛡️ Garantía 7 días</span>
        </div>
      </div>
    </section>;
}